import React, { useState, ReactType, useRef, useEffect } from 'react'
import get from 'lodash/get'
import './styles.scss'
import Loader from 'components/Loader'

import COLORS from '../../styles/colors'

import CorrectIcon from '../../assets/svgs/Correct'

export interface ISteps {
  title: string
  content: ReactType
  id: string | number
}

interface IPropTypes {
  steps: ISteps[]
  onClick?: (step: any, isClickable: boolean) => void | void
  selectedStep?: string | number
  loading?: boolean
}

export default function VerticalStep({ loading, steps, onClick, selectedStep }: IPropTypes) {
  const ref = useRef(null)
  const [linesHeight, setLinesHeight] = useState<any[]>([])

  useEffect(() => {
    //@ts-ignore
    const resizeObserver = new ResizeObserver((entries) => {
      handleLinesSize(entries[0])
    })

    resizeObserver.observe(ref.current)
    // eslint-disable-next-line
  }, [ref.current])

  useEffect(() => {
    handleChangeClickable(selectedStep)
    // eslint-disable-next-line
  }, [selectedStep])
  const clickable = {}
  steps.forEach((step, i) => (clickable[step.id] = i === 0))

  const [isClickable, setClickable] = useState(clickable)

  const handleChangeClickable = (step) => {
    if (step) {
      const currentStepindex = steps.findIndex(({ id }) => id === step)
      const updatedClickables = {}

      steps.some((step, id) => {
        updatedClickables[step.id] = true
        return id === currentStepindex
      })

      setClickable({ ...isClickable, ...updatedClickables })
    }
  }

  const handleClick = (step, index) => {
    if (Boolean(onClick)) {
      //@ts-ignore
      onClick(step, isClickable[step.id])
    }
  }

  const handleLinesSize = (resizeObserverEntry) => {
    const children = resizeObserverEntry.target.children
    const tabs: any[] = []
    for (let i in children) {
      if (typeof children[i] === 'object') {
        const currentTabOffsetTop = get(children[i], 'offsetTop')
        const offsetHeight = get(children[i], 'offsetHeight')
        tabs.push({ offsetHeight, currentTabOffsetTop, id: children[i].id })
      }
    }

    const tabsWithLineSize = tabs.map((tab, index) => {
      if (tabs[index + 1]) {
        const withLine = {
          ...tab,
          linesHeight: tabs[index + 1].currentTabOffsetTop - tab.currentTabOffsetTop,
        }
        return withLine
      }
      return tab
    })

    setLinesHeight(tabsWithLineSize)
  }

  const getVerticalLineSytling = (index) => {
    const currentLine = linesHeight[index]
    let nextTabOffsetTop = get(linesHeight[index + 1], 'currentTabOffsetTop')

    if (get(currentLine, 'linesHeight')) {
      let height = currentLine.linesHeight - 55

      if (currentLine.id === selectedStep) {
        nextTabOffsetTop -= currentLine.offsetHeight - 85
        height -= 20
      }
      return {
        height,
        width: 2,
        backgroundColor: isClickable[currentLine.id] ? COLORS.greyscale.dark : COLORS.lightGray,
        top: nextTabOffsetTop != null ? nextTabOffsetTop - 50 : 0,
        left: 14,
      }
    }
  }

  const getStepIndicator = (step, i) => {
    let className = 'step-indicator'

    if (isClickable[step.id]) className += ' active'

    const Icon =
      isClickable[step.id] && step.id !== selectedStep && selectedStep ? (
        <CorrectIcon />
      ) : (
        `${i + 1}`
      )

    return (
      <span id={`${step.title}`} className={className}>
        {Icon}
      </span>
    )
  }

  return (
    <div ref={ref} className='vertical-step-container'>
      {steps.map((step, i) => (
        //@ts-ignore
        <div id={step.id} className='step-container' key={`${step.title}${i}`}>
          <div className='position-absolute' style={getVerticalLineSytling(i)} />
          <div onClick={() => handleClick(step, i)} className='step-tab'>
            {getStepIndicator(step, i)}
            <h3>{step.title}</h3>
          </div>
          {step.id === selectedStep && (
            <div className='content-area'>
              {loading && (
                <div className='loader-wrapper'>
                  <Loader />
                </div>
              )}
              <step.content />
            </div>
          )}
        </div>
      ))}
    </div>
  )
}
